import { render } from "./FormAccountComponent.vue?vue&type=template&id=d4fca988"
import script from "./FormAccountComponent.vue?vue&type=script&lang=js"
export * from "./FormAccountComponent.vue?vue&type=script&lang=js"

import "./FormAccountComponent.vue?vue&type=style&index=0&id=d4fca988&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__